import { memo } from "react";
import { Alert, AlertAction, AlertDescription } from "../ui/alert";
import { Button } from "../ui/button";
import { CircleAlertIcon, XIcon } from "lucide-react";
import { canSendFeedback, reportFeedbackProblem } from "../settings/FeedbackDialog";

export const ThreadErrorBanner = memo(function ThreadErrorBanner({
  error,
  onDismiss,
}: {
  error: string | null;
  onDismiss?: () => void;
}) {
  if (!error) return null;
  return (
    <div className="w-full max-w-3xl px-3 pt-3 sm:px-5 mx-auto">
      <Alert variant="error" className="w-full">
        <CircleAlertIcon />
        <AlertDescription className="min-w-0 flex-1 whitespace-pre-wrap break-words" title={error}>
          {error}
        </AlertDescription>
        {canSendFeedback() || onDismiss ? (
          <AlertAction>
            {canSendFeedback() ? (
              <Button
                variant="ghost"
                size="xs"
                onClick={() =>
                  reportFeedbackProblem({
                    origin: "thread-error",
                    summary: "A thread stopped with an error",
                    message: error,
                    occurredAt: new Date().toISOString(),
                  })
                }
              >
                Report this problem
              </Button>
            ) : null}
            {onDismiss ? (
              <Button variant="ghost" size="icon-xs" aria-label="Dismiss error" onClick={onDismiss}>
                <XIcon className="text-destructive" />
              </Button>
            ) : null}
          </AlertAction>
        ) : null}
      </Alert>
    </div>
  );
});
